import { render, staticRenderFns } from "./realOrderRecord.vue?vue&type=template&id=7dc94d81"
import script from "./realOrderRecord.vue?vue&type=script&lang=js"
export * from "./realOrderRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports